// extracted by mini-css-extract-plugin
export default {"invictus_logo":"invictusresult_invictus_logo__noNCI"};